import {dateField, EntityData, field, identifier} from "@fedeltapointofsale/data-client";
import {EntitlementStatus} from "./entitlement.data";

export class EntitlementSearchData extends EntityData<EntitlementSearchData> {
    @identifier id: string;
    @field distributionType: string;
    @field distributionReference: string;
    @field externalId: string;
    @dateField issueDate: Date;
    @dateField expiryDate: Date;
    @field status: EntitlementStatus;
    @field usageLimit: number;
    @field usageCount: number;

    get displayStatus(): EntitlementStatus {
        return this.status == EntitlementStatus.DISCONTINUED ? EntitlementStatus.DISCONTINUED
            : this.expiryDate < new Date() ? EntitlementStatus.EXPIRED
                : this.usageLimit && this.usageCount >= this.usageLimit ? EntitlementStatus.CONSUMED
                : this.status;
    }

    get usage(): string {
        return this.usageLimit ? this.usageCount + " of " + this.usageLimit : this.usageCount + "";
    }

    get summary(): String {
        return this.distributionReference + (this.externalId ? ( " - " + this.externalId) : "");
    }
}
